global.server = "https://dev.involvedk12.org/";